import * as z from 'zod'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'
import { toStandardSchema } from '../utils/schema'

export const HARMONY_PACKAGE_BOARD_WORKITEM_HISTORY_TABLE = '"public"."harmonyPackageBoardWorkitemColumnHistory"'

export const HarmonyPackageBoardWorkitemColumnHistoryFetchZodSchema = z.object({
  id: z.string().min(5, 'History ID is required').default('-----'),
  harmonyPackageBoardWorkitemId: z.string().min(5, 'Workitem ID is required'),
  columnId: z.string().min(5, 'From Column ID is required'),
  createdAt: z.date().default(() => new Date()),
  statusChangedAt: z.date().optional(),
  timeInColumn: z.number().optional(),
  workspaceId: z.uuid('Workspace ID must be a valid UUID'),
  column: z.any().optional(),
  item: z.any().optional(),
  workspace: z.any().optional(),
})

export const HarmonyPackageBoardWorkitemColumnHistorySchema = toStandardSchema(
  HarmonyPackageBoardWorkitemColumnHistoryFetchZodSchema,
)

export const HarmonyPackageBoardWorkitemColumnHistoryConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: HARMONY_PACKAGE_BOARD_WORKITEM_HISTORY_TABLE,
  partitionKey: 'harmonyPackageBoardWorkitemId',
  key: 'id',
  apiEndpoint: '/api/board-column-history',
  where: {},
  schema: HarmonyPackageBoardWorkitemColumnHistorySchema,
}
